module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.625 1.875H4.5C4.56875 1.875 4.625 1.81875 4.625 1.75V1.875H9.375V1.75C9.375 1.81875 9.43125 1.875 9.5 1.875H9.375V3H10.5V1.75C10.5 1.19844 10.0516 0.75 9.5 0.75H4.5C3.94844 0.75 3.5 1.19844 3.5 1.75V3H4.625V1.875ZM12.5 3H1.5C1.22344 3 1 3.22344 1 3.5V4C1 4.06875 1.05625 4.125 1.125 4.125H2.06875L2.45469 12.2969C2.47969 12.8297 2.92031 13.25 3.45313 13.25H10.5469C11.0813 13.25 11.5203 12.8313 11.5453 12.2969L11.9313 4.125H12.875C12.9438 4.125 13 4.06875 13 4V3.5C13 3.22344 12.7766 3 12.5 3ZM10.4266 12.125H3.57344L3.19531 4.125H10.8047L10.4266 12.125Z",
      "fill": _vm.color ? _vm.color : 'black',
      "fill-opacity": _vm.opacity ? _vm.opacity : '0.45'
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e25bbe2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/Delete.vue
// module id = 1507
// module chunks = 159